import React, { lazy } from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";

const ContractTemplatesList = lazy(() => import("../../container/pages/contractTemplates/index"));

function ContractTemplatesRoute() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}`} component={ContractTemplatesList} />
    </Switch>
  );
}

export default ContractTemplatesRoute;
